export default {
  messages: {
    companyName: 'Shanghai Peixi Consulting Co., Ltd.',
    home: 'Home',
    about: 'About Us',
    products: 'Our Services',
    contact: 'Contact Us',
    copyright: '© {year} — Shanghai Peixi Consulting Co., Ltd.',
    welcome: 'Welcome to our company!'
  }
}